import { FC } from "react";

import { STEP_TO_ELEMENT_ID } from "@/features/LiveFormEditor/AnimatePreview/Arrow/ArrowContext";
import {
  FormCampaignTargetThermometer,
  FormCampaignTargetThermometerProps,
} from "@/forms-design-system/FormCampaignTargetThermometer";
import { useTranslate } from "@/hooks/useTranslate";

type ThemedFormCampaignTargetThermometerProps = Omit<FormCampaignTargetThermometerProps, "label">;

export const ThemedFormCampaignTargetThermometer: FC<ThemedFormCampaignTargetThermometerProps> = ({ ...rest }) => {
  const { t } = useTranslate();

  return (
    <FormCampaignTargetThermometer
      id={STEP_TO_ELEMENT_ID["fundraising-goal"]}
      label={{
        renderCurrentAmount: (currentCollectedAmount: string, targetedAmount: string) =>
          t("ticketing", "thermometer", {
            value: currentCollectedAmount,
            goal: targetedAmount,
          }),
        ongoingCampaign0To49: t("ticketing", "thermometer.promote.1"),
        ongoingCampaign50To79: t("ticketing", "thermometer.promote.2"),
        ongoingCampaign80To99: t("ticketing", "thermometer.promote.3"),
        campaignAchieved: t("ticketing", "thermometer.promote.4"),
      }}
      {...rest}
    />
  );
};
